(function() {
  if (window._langifyTurboFixApplied) return;
  window._langifyTurboFixApplied = true;

  const _pushState = history.pushState;
  history.pushState = function() {
    _pushState.apply(history, arguments);
    document.dispatchEvent(new Event('turbo:navigation'));
  };

  const _replaceState = history.replaceState;
  history.replaceState = function() {
    _replaceState.apply(history, arguments);
    document.dispatchEvent(new Event('turbo:navigation'));
  };

  function reloadLangify() {
    const _langify = window.langify;
    if (_langify) {
        _langify.switcher?.init();
        console.log('[Langify]: reloaded');
    }
  }

  function updateHomeLinks() {
    const origin = window.location.origin;
    const localePrefix = (window.langify && langify.locale && langify.locale.root_url) || "/";
    document.querySelectorAll(`a[href="${origin}"]`).forEach(a => {
      a.setAttribute("href", `${origin}${localePrefix}`);
    });
  }

  document.addEventListener("turbo:navigation", function() {
    updateHomeLinks();
    setTimeout(reloadLangify, 150);
  });
  document.addEventListener("DOMContentLoaded", updateHomeLinks);
})();
